<div>
  <table
    class="uk-table uk-table-hover uk-table-divider"
    style="width: 100%"
    datatable
    [dtOptions]="dtOptions"
    [dtTrigger]="dtTrigger"
    id="shipmentListTable"
  >
    <thead>
      <tr >
        <th style="width: 13%">Numer listu przewozowego</th>
        <th>{{'recipient_name' | translate}}</th>
        <th *ngIf="userRole < UserRole.client">{{'client' | translate}}</th>
        <th>{{'destination_city' | translate}}</th>
        <th>{{'out_number' | translate}}</th>
        <th>{{'declared_content' | translate}}</th>
        <th>{{'cash_on_delivery_value' | translate}}</th>
        <th>{{'created_at' | translate}}</th>
      </tr>
    </thead>
    <tfoot  id="footer">
    </tfoot>
    <tbody *ngIf="shipments?.length > 0">
      <tr *ngFor="let shipment of shipments"
          (click)="goTo(shipment.internal_waybill)"
          (mouseout)="setGoToLocker(false)"
      >
        <td (mouseup)="setGoToLocker(true)">
          <img src="{{shipmentFlagUrl(shipment)}}" title="{{shipmentCountry(shipment)}}">
          <kbd>{{shipment.internal_waybill}}</kbd>
        </td>

        <td>{{shipment.recipient_name}}</td>
        <td *ngIf="userRole < UserRole.client">{{shipment.client_name}}</td>
        <td>{{isReturn(shipment) ? shipment.sender_locality_name : shipment.recipient_locality_name}}</td>
        <td (mouseup)="setGoToLocker(true)">
          {{ isReturn(shipment) ? shipment.in_waybill : shipment.out_waybill}}
        </td>
        <td>{{shipment.declared_content}}</td>
        <td>{{shipment.cash_on_delivery ? shipment.cash_on_delivery_value + ' ' + shipment.currency : '-'}}</td>
        <td>{{shipment.created_at}}</td>
      </tr>
    </tbody>
  </table>
</div>
